import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from "rxjs/operators";
import { CardEnvironment } from "src/model/class/general classes/card-environment";
import { CardEnvironmentStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { CardsService } from "src/service/cards.service";
import {
  cardEnvironmentLoadErrorAction,
  cardEnvironmentLoadSuccessAction,
} from "../actions/card-environment.actions";
import { currentUserData } from "../selectors/authentication.selectors";

/**
 * Handle generic side ngrx effect from area action
 */
@Injectable()
export class CardEnvironmentEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store,
    private _cardService: CardsService
  ) { }

  /**
   * Effet attached to ngrx store init, then start init initialization
   */
  public cardEnvironmentStartInitEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(CardEnvironmentStoreAction.CARD_ENVIRONMENT_START_LOAD),
      withLatestFrom(this._store.select(currentUserData)),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((combinedObject: any) => {
        return this._cardService
          .getCardEnvironmentsByIDCard(combinedObject[0].idCard)
          .pipe(
            map((listCardEnvironment: Array<CardEnvironment>) => {
              listCardEnvironment = listCardEnvironment.filter(
                (cardEnvironment: CardEnvironment) => cardEnvironment.active
              );

              return cardEnvironmentLoadSuccessAction({
                listCardEnvironmentObject: {
                  data: listCardEnvironment,
                  lastAPIModified: null,
                },
              });
            }),
            catchError(() => of(cardEnvironmentLoadErrorAction()))
          );
      })
    )
  );
}
